/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateCnuContactRequestJobMutationRequest,
  CreateCnuContactRequestJobMutationResponse,
  CreateCnuContactRequestJob400,
} from '../types/CreateCnuContactRequestJob'

function getCreateCnuContactRequestJobUrl() {
  const res = { method: 'POST', url: `/api/v1/contact_request/cnu/` as const }
  return res
}

/**
 * @summary Create a contact request job for colleges/universities
 * {@link /api/v1/contact_request/cnu/}
 */
export async function createCnuContactRequestJob(
  data: CreateCnuContactRequestJobMutationRequest,
  config: Partial<RequestConfig<CreateCnuContactRequestJobMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateCnuContactRequestJobMutationResponse,
    ResponseErrorConfig<CreateCnuContactRequestJob400>,
    CreateCnuContactRequestJobMutationRequest
  >({
    method: 'POST',
    url: getCreateCnuContactRequestJobUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
